// endpoint: http://localhost:8000/api/offer-mechanisms/
const offerMechanisms = {
    offer_mechanisms: [
        {
            cluster_id: 1,
            mech_name: "pxe",
            mech_friendly: "PXE"
        },
        {
            cluster_id: 2,
            mech_name: "preferred_pricing",
            mech_friendly: "PREFERRED PRICING"
        },
        {
            cluster_id: 3,
            mech_name: "planned_package",
            mech_friendly: "PLANNED PACKAGE"
        },
        {
            cluster_id: 4,
            mech_name: "bulk_awareness",
            mech_friendly: "BULK AWARENESS"
        },
        {
            cluster_id: 5,
            mech_name: "percent_discount",
            mech_friendly: "% DISCOUNT"
        }
    ]
}

// endpoint: http://localhost:8000/api/target-segments/
const targetSegments = {
    target_segments: [
        {
            targeting_segment_id: 54,
            targeting_segment_name: "Kansas Renovators",
            target_id_seq: 71,
            target_count: 12356
        },
        {
            targeting_segment_id: 55,
            targeting_segment_name: "Kansas Handyperson",
            target_id_seq: 69,
            target_count: 4083
        },
        {
            targeting_segment_id: 57,
            targeting_segment_name: "Georgia Renovators R12$15000",
            target_id_seq: 65,
            target_count: 11837
        },
        {
            targeting_segment_id: 71,
            targeting_segment_name: "California Handyperson R12>15000",
            target_id_seq: 15,
            target_count: 6944
        },
        {
            targeting_segment_id: 74,
            targeting_segment_name: "Texas Handyperson R12>15000",
            target_id_seq: 148,
            target_count: 2725
        },
        {
            targeting_segment_id: 73,
            targeting_segment_name: "California Plumbers",
            target_id_seq: 16,
            target_count: 11799
        },
        {
            targeting_segment_id: 72,
            targeting_segment_name: "New Mexico Handyperson",
            target_id_seq: 102,
            target_count: 2576
        },
        {
            targeting_segment_id: 65,
            targeting_segment_name: "Colorado Electricians",
            target_id_seq: 17,
            target_count: 3482
        },
        {
            targeting_segment_id: 67,
            targeting_segment_name: "Illinois Electricians",
            target_id_seq: 68,
            target_count: 4267
        },
        {
            targeting_segment_id: 70,
            targeting_segment_name: "Colorado Painters",
            target_id_seq: 18,
            target_count: 5457
        },
        {
            targeting_segment_id: 59,
            targeting_segment_name: "Florida Carpenters",
            target_id_seq: 46,
            target_count: 12255
        },
        {
            targeting_segment_id: 60,
            targeting_segment_name: "Massachusetts Carpenters",
            target_id_seq: 93,
            target_count: 10018
        },
        {
            targeting_segment_id: 64,
            targeting_segment_name: "Florida Landscaping",
            target_id_seq: 49,
            target_count: 8170
        },
        {
            targeting_segment_id: 82,
            targeting_segment_name: "New York Landscapers",
            target_id_seq: 103,
            target_count: 3458
        },
        {
            targeting_segment_id: 84,
            targeting_segment_name: "New York Plumbers",
            target_id_seq: 104,
            target_count: 3081
        },
        {
            targeting_segment_id: 83,
            targeting_segment_name: "Texas Landscapers",
            target_id_seq: 149,
            target_count: 10607
        }
    ]
}

// endpoint: http://localhost:8000/api/product-segments/
const productSegments = {
    product_segments: [
        {
            product_segment_id: 541,
            product_segment_name: "Algo - White Floor Tiles",
            product_id_seq: 20
        },
        {
            product_segment_id: 542,
            product_segment_name: "Algo - Decking",
            product_id_seq: 15
        },
        {
            product_segment_id: 543,
            product_segment_name: "Algo - Glacier Bay",
            product_id_seq: 19
        },
        {
            product_segment_id: 544,
            product_segment_name: "Algo - Drywall",
            product_id_seq: 18
        },
        {
            product_segment_id: 545,
            product_segment_name: "Algo - D22",
            product_id_seq: 14
        }

    ]
}

// endpoint: http://localhost:8000/api/prediction/user=kyle@block-tackle.com/cluster=3&product=573&target=142
const predictionSources = [
    {
        id: 1,
        prediction_id: 1,
        targeting_segment_id: 54,
        cluster_id: 1,
        product_segment_id: 541,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "45%",
        condition_confidence: "LOW",
        target_count: 12356
    },
    {
        id: 2,
        prediction_id: 2,
        targeting_segment_id: 55,
        cluster_id: 1,
        product_segment_id: 541,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "42%",
        condition_confidence: "LOW",
        target_count: 4083
    },
    {
        id: 3,
        prediction_id: 3,
        targeting_segment_id: 57,
        cluster_id: 1,
        product_segment_id: 541,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "29%",
        condition_confidence: "LOW",
        target_count: 11837
    },
    {
        id: 4,
        prediction_id: 4,
        targeting_segment_id: 71,
        cluster_id: 4,
        product_segment_id: 544,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "14%",
        condition_confidence: "HIGH",
        target_count: 6944
    },
    {
        id: 5,
        prediction_id: 5,
        targeting_segment_id: 74,
        cluster_id: 4,
        product_segment_id: 544,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "15%",
        condition_confidence: "HIGH",
        target_count: 2725
    },
    {
        id: 6,
        prediction_id: 6,
        targeting_segment_id: 73,
        cluster_id: 4,
        product_segment_id: 544,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "1%",
        condition_confidence: "HIGH",
        target_count: 11799
    },
    {
        id: 7,
        prediction_id: 7,
        targeting_segment_id: 72,
        cluster_id: 4,
        product_segment_id: 544,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: ".05%",
        condition_confidence: "HIGH",
        target_count: 2576
    },
    {
        id: 8,
        prediction_id: 8,
        targeting_segment_id: 65,
        cluster_id: 3,
        product_segment_id: 542,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "0%",
        condition_confidence: "HIGH",
        target_count: 3482
    },
    {
        id: 9,
        prediction_id: 9,
        targeting_segment_id: 67,
        cluster_id: 3,
        product_segment_id: 542,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "0%",
        condition_confidence: "HIGH",
        target_count: 4276
    },
    {
        id: 10,
        prediction_id: 10,
        targeting_segment_id: 70,
        cluster_id: 3,
        product_segment_id: 542,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "0%",
        condition_confidence: "HIGH",
        target_count: 5457
    },
    {
        id: 11,
        prediction_id: 11,
        targeting_segment_id: 59,
        cluster_id: 2,
        product_segment_id: 545,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "24%",
        condition_confidence: "LOW",
        target_count: 12255
    },
    {
        id: 12,
        prediction_id: 12,
        targeting_segment_id: 60,
        cluster_id: 2,
        product_segment_id: 545,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "32%",
        condition_confidence: "MEDIUM",
        target_count: 10018
    },
    {
        id: 13,
        prediction_id: 13,
        targeting_segment_id: 64,
        cluster_id: 2,
        product_segment_id: 545,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "20%",
        condition_confidence: "LOW",
        target_count: 8170
    },
    {
        id: 14,
        prediction_id: 14,
        targeting_segment_id: 82,
        cluster_id: 5,
        product_segment_id: 543,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "4%",
        condition_confidence: "MEDIUM",
        target_count: 3458
    },
    {
        id: 15,
        prediction_id: 15,
        targeting_segment_id: 84,
        cluster_id: 5,
        product_segment_id: 543,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "6%",
        condition_confidence: "MEDIUM",
        target_count: 3081
    },
    {
        id: 16,
        prediction_id: 16,
        targeting_segment_id: 83,
        cluster_id: 5,
        product_segment_id: 543,
        prediction_dt: "2022-03-03",
        prediction_completion_dt: "2022-03-03",
        take_rate: "4%",
        condition_confidence: "MEDIUM",
        target_count: 10607
    }
]

// // endpoint: http://localhost:8000/api/prediction/user=kyle@block-tackle.com/cluster=3&product=573&target=142
// const expiredPredictionSource = {}

// // endpoint: 
// const exisitngPredictionSource = {}

// // endpoint: 
// const existingTarget = {}

// // endpoint: 
// const existingProduct = {}

export {
    offerMechanisms,
    targetSegments,
    productSegments,
    predictionSources
};